<template>
  <div>
    <b-card
      v-if="showHelpvideoList"
      class="help-video-list-modal p-1 mb-0"
      :style="anchorStyle"
      no-body
    >
      <h4>{{ $t('help-videos-moduel.help-videos-list') }}</h4>
      <b-overlay
        :show="isProcessing"
      >
        <template v-if="isASchool || isATeacher">
          <v-select
            id="video-language"
            v-model="language"
            name="Language"
            :options="languageList"
            :reduce="(item) => item.value"
            :placeholder="$t('help-videos-moduel.select-language')"
            @input="getVideoByLanguage"
          />
        </template>
        <ul
          v-if="videoList.length > 0"
          class="mt-1 pl-0"
        >
          <li
            v-for="(video, index) in videoList"
            :key="index"
          >
            <a @click.prevent="showHelpvideoModal(video)">
              <feather-icon
                icon="PlayIcon"
                size="12"
                style="margin-top:5px"
              />
              <span class="ml-1">{{ video.title }}</span>
            </a>
          </li>
        </ul>
        <b-alert
          v-else
          show
          variant="warning"
          class="p-1"
        >
          <span>{{ $t('messages.no-videos-available') }}</span>
        </b-alert>
      </b-overlay>
    </b-card>

    <!-- Video popover anchored below the help button -->
    <transition name="hvp-fade">
      <div
        v-if="embededUrl"
        class="hvp-popover"
        :style="anchorStyle"
      >
        <div class="hvp-popover-header">
          <span class="hvp-popover-title">{{ selectedVideo.title }}</span>
          <button
            class="hvp-close-btn"
            @click="closeVideoPopover"
          >
            <feather-icon
              icon="XIcon"
              size="14"
            />
          </button>
        </div>
        <div class="hvp-video-wrapper">
          <iframe
            :src="embededUrl"
            width="100%"
            height="210"
            frameborder="0"
            allowfullscreen
          />
        </div>
        <p
          v-if="selectedVideo.description"
          class="hvp-description"
        >
          <span v-html="selectedVideo.description" />
        </p>
        <div class="hvp-footer">
          <label class="hvp-footer-label">
            {{ $t('help-videos-moduel.dont-show-again') }}
            <input
              v-model="viewLaterValue"
              type="checkbox"
              @change="viewLater"
            >
          </label>
        </div>
      </div>
    </transition>

    <!--Button-->
    <div class="w-100">
      <b-button
        ref="helpBtn"
        v-b-tooltip.bottom.hover
        variant="success"
        class="help-video-btn"
        :title="$t('help-videos-moduel.toolttip-title')"
        :class="{ active: showHelpvideoList }"
        @click="toggleList"
      >
        <feather-icon
          :icon="showHelpvideoList ? 'XIcon' : 'VideoIcon'"
          size="18"
        />
      </b-button>
    </div>
    <!--Button-->
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import {
  USER_TYPE_SCHOOL,
  USER_TYPE_TEACHER,
} from '@/const/userType'
import { isVisible } from '@/utils/visibilitySettings'
import {
  BButton, VBTooltip, BCard, BOverlay, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'HelpVideoList',
  components: {
    BButton,
    BCard,
    BOverlay,
    BAlert,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    userType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showHelpvideoList: false,
      videoList: [],
      selectedVideo: {},
      embededUrl: null,
      isProcessing: false,
      languageList: [
        { value: 'English', label: 'English' },
        { value: 'Spanish', label: 'Español' },
        { value: 'Korean', label: '한국어' },
        { value: 'Japanese', label: '日本語' },
        { value: 'Vietnamese', label: 'Tiếng Việt' },
        { value: 'Hindi', label: 'हिन्दी, हिंदी' },
      ],
      language: null,
      viewLaterValue: false,
      anchorPosition: { top: 0, right: 0 },
    }
  },
  computed: {
    isASchool() {
      return this.userType === USER_TYPE_SCHOOL
    },
    isATeacher() {
      return this.userType === USER_TYPE_TEACHER
    },
    popupHelpVideo() {
      const schoolSettings = this.$store.state.appConfig?.schoolInfo?.user_meta
      const districtSettings = this.$store.state.appConfig?.districtInfo?.user_meta

      if (!schoolSettings && !districtSettings) return false

      return isVisible('help_video_pop_up', schoolSettings, districtSettings)
    },
    anchorStyle() {
      return {
        top: `${this.anchorPosition.top}px`,
        right: `${this.anchorPosition.right}px`,
      }
    },
  },
  watch: {
    popupHelpVideo(val) {
      if (val) {
        if (!this.viewLaterValue && this.popupHelpVideo && this.videoList.length) { this.showHelpvideoModal(this.videoList[0]) }
      }
    },
  },
  created() {
    this.getHelpVideosList()
  },
  mounted() {
    this.updateAnchorPosition()
  },
  methods: {
    updateAnchorPosition() {
      this.$nextTick(() => {
        const btn = this.$refs.helpBtn?.$el
        if (!btn) return
        const rect = btn.getBoundingClientRect()
        this.anchorPosition = {
          top: rect.bottom + 10,
          right: window.innerWidth - rect.right,
        }
      })
    },
    toggleList() {
      this.showHelpvideoList = !this.showHelpvideoList
      this.updateAnchorPosition()
    },
    getHelpVideosList() {
      this.isProcessing = true
      useJwt.getAllRelatedHelpVideos()
        .then(res => {
          this.videoList = res.data.data
          this.viewLaterValue = res.data.viewLater
        })
        .catch(error => {
          console.log(error)
        }).finally(() => {
          this.isProcessing = false
        })
    },
    showHelpvideoModal(video) {
      this.selectedVideo = video
      if (this.selectedVideo.link.includes('youtube.com/watch')) {
        const videoId = this.selectedVideo.link.split('v=')[1]
        this.embededUrl = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`
      } else {
        this.embededUrl = this.selectedVideo.link
      }
      this.showHelpvideoList = false
      this.updateAnchorPosition()
    },
    closeVideoPopover() {
      this.selectedVideo = {}
      this.embededUrl = null
    },
    getVideoByLanguage() {
      this.isProcessing = true
      useJwt.getAllRelatedHelpVideos({
        params: {
          language: this.language,
        },
      })
        .then(res => {
          this.videoList = res.data?.data
        })
        .catch(error => {
          console.log(error)
        }).finally(() => {
          this.isProcessing = false
        })
    },
    viewLater() {
      useJwt.storeUserMeta('viewLater', this.viewLaterValue).then(res => {
        this.showSuccessMessage(res.data.message)
      }).catch(error => {
        console.log(error)
      })
    },
  },
}

</script>

<style lang="scss" scoped>
.help-video-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0 12px;
    bottom: 30px;
    z-index: 10000;
    // position: fixed;
    border: 2px solid white !important;
}

.help-video-btn.btn-success {
    right: 2%;
    top: 35%;
}

.help-video-list-modal {
    position: fixed;
    z-index: 10001;
    width: 300px;
    max-height: 340px;
    overflow-y: auto;
}

.help-video-list-modal ul li {
    margin-bottom: 4px;
}
.help-video-list-modal ul li a{
    display: flex;
    font-size: 16px;
    color: #000;
}
.help-video-list-modal ul li a:hover span{
    text-decoration: underline;
}

/* Video popover */
.hvp-popover {
  position: fixed;
  z-index: 10001;
  width: 340px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.hvp-popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  gap: 8px;
}

.hvp-popover-title {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.hvp-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s;

  &:hover {
    background: #e53935;
  }
}

.hvp-video-wrapper {
  line-height: 0;

  iframe {
    display: block;
  }
}

.hvp-description {
  font-size: 13px;
  color: #333;
  padding: 8px 12px 0;
  margin: 0;
}

.hvp-footer {
  padding: 8px 12px;
  border-top: 1px solid #f0f0f0;
}

.hvp-footer-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #555;
  cursor: pointer;
  margin: 0;

  input {
    cursor: pointer;
  }
}

/* Transition */
.hvp-fade-enter-active,
.hvp-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.hvp-fade-enter,
.hvp-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
